import Box from "ds/components/Box";
import { AccessResult } from "utils/access";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import PromoteRunButton from "components/Run/elements/PromoteRunButton";

import { RunHistoryEntryType } from "../../types";

type FinishedEntryProps = {
  timestamp: number;
  canPromote: AccessResult;
  stackId: string;
  runId: string;
};

const FinishedEntry = ({ timestamp, stackId, canPromote, runId }: FinishedEntryProps) => {
  const canShowPromoteButton = canPromote.result || canPromote.message;
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.Finished} timestamp={timestamp} terminal>
      {canShowPromoteButton && (
        <Box>
          <PromoteRunButton stackId={stackId} runId={runId} errorMessage={canPromote.message} />
        </Box>
      )}
    </HistoryEntryWrapper>
  );
};

export default FinishedEntry;
